export const payoutsItemRows = {
  Surrender: {
    name: 'SURRENDER',
  },
  BlackJack: {
    name: 'BLACKJACK',
  },
  BestHand: {
    name: 'WIN',
  },
  Insurance: {
    name: 'INSURANCE',
  },
  Flush: {
    name: 'FLUSH',
    className: ['diamond', 'diamond', 'diamond'],
    card: ['Q', 'J', '3'],
    cardIcons: ['icon-diamond-suit', 'icon-diamond-suit', 'icon-diamond-suit'],
  },
  Straight: {
    name: 'STRAIGHT',
    className: ['spades', 'hearts', 'clubs'],
    card: ['Q', 'J', '10'],
    cardIcons: ['icon-spades-suit', 'icon-hearts-suit', 'icon-clubs-suit'],
  },
  ThreeOfaKind: {
    name: 'THREE_OF_A_KIND',
    className: ['spades', 'hearts', 'clubs'],
    card: ['Q', 'Q', 'Q'],
    cardIcons: ['icon-spades-suit', 'icon-hearts-suit', 'icon-clubs-suit'],
  },
  StraightFlush: {
    name: 'STRAIGHT_FLUSH',
    className: ['spades', 'spades', 'spades'],
    card: ['Q', 'J', '10'],
    cardIcons: ['icon-spades-suit', 'icon-spades-suit', 'icon-spades-suit'],
  },
  SuitThreeOfaKind: {
    name: 'SUITED_TRIPS',
    className: ['hearts', 'hearts', 'hearts'],
    card: ['Q', 'Q', 'Q'],
    cardIcons: ['icon-hearts-suit', 'icon-hearts-suit', 'icon-hearts-suit'],
  },
  MixedPair: {
    name: 'MIXED_PAIR',
    className: ['spades', 'hearts'],
    card: ['Q', 'Q'],
    cardIcons: ['icon-spades-suit', 'icon-hearts-suit'],
  },
  ColoredPair: {
    name: 'COLORED_PAIR',
    className: ['diamond', 'hearts'],
    card: ['Q', 'Q'],
    cardIcons: ['icon-diamond-suit', 'icon-hearts-suit'],
  },
  PerfectPair: {
    name: 'PERFECT_PAIR',
    className: ['hearts', 'hearts'],
    card: ['Q', 'Q'],
    cardIcons: ['icon-hearts-suit', 'icon-hearts-suit'],
  },
};

export const BET_TYPES_LIMITS_KEYS = {
  main: 'MAIN',
  side21plus3: 'SIDE_21_PLUS_3',
  sidePerfectPair: 'PERFECT_PAIR',
};
